exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._29bWP{border:3px solid #66ead0;background-color:#fff;font-size:18px;font-weight:500}._29bWP ._1LyFi{text-align:center;text-transform:capitalize;font-weight:700;padding:.5em 0;font-size:20px;background-color:#66ead0}._29bWP .AZgK9{padding:0 15px}._29bWP .AZgK9 ._34gMH{margin:0}._29bWP .AZgK9 ._33jEe{margin:.5em 0}._29bWP .AZgK9 ._33jEe ._37nyL{text-align:center;text-transform:capitalize;font-weight:700;margin:0;padding:5px;border-bottom:.1px solid #1d1d1d;font-size:20px}._29bWP .AZgK9 ._33jEe ._30x-a{font-weight:600}._29bWP .AZgK9 ._33jEe ._2-HKs{padding-left:0;text-align:left}._29bWP .AZgK9 ._33jEe ._2nbGg{padding-right:0;text-align:right;float:right}._29bWP .AZgK9 ._33jEe .a8mIT{text-align:center}._29bWP .AZgK9 ._33jEe ._1d6xK{font-size:17px;font-weight:500}._29bWP .AZgK9 ._33jEe ._23udd{color:#66ead0;font-weight:700}", ""]);

// exports
exports.locals = {
	"teal": "#00dcb2",
	"grey": "#b4b4b4",
	"orange": "#ff4e32",
	"sick": "#673ab7",
	"vacation": "#cddc39",
	"holiday": "#4caf50",
	"card": "_29bWP",
	"cardTitle": "_1LyFi",
	"cardItemsWrapper": "AZgK9",
	"itemMetricGroup": "_34gMH",
	"cardItem": "_33jEe",
	"cardSubTitle": "_37nyL",
	"displayName": "_30x-a",
	"alignLeft": "_2-HKs",
	"alignRight": "_2nbGg",
	"alignCenter": "a8mIT",
	"biggerText": "_1d6xK",
	"cardItemEnvSubtitle": "_23udd"
};